export const ToujouStorageBehaviour = superClass => class extends superClass {
  constructor() {
    super();
    this.storageName = 'toujou-fav';
    window.addEventListener('storage', (event) => {
      this._handleStorageEvent(event);
    });
    document.addEventListener('toujou-storage-save', (event) => {
      this._handleStorageEvent(event);
    });
    window.requestIdleCallback(() => {
      this.loadStorageValue();
    });
  }

  loadStorageValue() {
    this._loaded = false;
    this._load();
  }

  saveStorageValue(storageValue) {
    try {
      if (storageValue === null || storageValue === undefined) {
        window.localStorage.removeItem(this.storageName);
      } else {
        const itemValue = this.useRawStorageValue
          ? storageValue
          : JSON.stringify(storageValue);
        window.localStorage.setItem(this.storageName, itemValue);
      }
      const event = new CustomEvent('toujou-storage-save', {
        detail: { name: this.storageName, value: storageValue },
        bubbles: false,
        composed: true,
      });

      document.dispatchEvent(event);
    } catch (ex) {
      // Happens in Safari incognito mode,
      this.storageErrorMessage = ex.message;
      // eslint-disable-next-line no-console
      console.error(
        'localStorage could not be saved. Safari incognito mode?',
        ex,
      );
    }
  }

  _handleStorageEvent(ev) {
    if (
      ev.key === this.storageName
        || (ev.detail && ev.detail.name === this.storageName)
    ) {
      this._load(true);
    }
  }

  _load(externalChange) {
    let value;
    try {
      value = window.localStorage.getItem(this.storageName);
    } catch (ex) {
      this.storageErrorMessage = ex.message;
      // eslint-disable-next-line no-console
      console.error(
        'localStorage could not be loaded. Safari incognito mode?',
        ex,
      );
      return;
    }

    if (value === null) {
      this._loaded = true;
      this._doNotSave = true; // guard for save watchers
      this.storageValue = null;
      this._doNotSave = false;
      this.dispatchEvent(
        new CustomEvent('toujou-storage-load-empty', {
          detail: externalChange,
          bubbles: false,
        }),
      );
    } else {
      if (!this.useRawStorageValue) {
        try {
          // parse value as JSON
          value = JSON.parse(value);
        } catch (x) {
          this.storageErrorMessage = 'Could not parse local storage value';
          // eslint-disable-next-line no-console
          console.error('could not parse local storage value', value);
          value = null;
        }
      }
      this._loaded = true;
      this._doNotSave = true;
      this.storageValue = value;
      this._doNotSave = false;
      this.dispatchEvent(
        new CustomEvent('toujou-storage-load', {
          detail: externalChange,
          bubbles: false,
        }),
      );
    }
  }
};
